import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="flash"
export default class extends Controller {
    static targets = ['message']
    static values = { autoDismiss: Number }

    connect() {
        if (this.autoDismissValue && this.messageTargets.length > 0) {
            this.timeout = setTimeout(() => this.closeAll(), this.autoDismissValue)
        }
    }

    disconnect() {
        clearTimeout(this.timeout)
    }

    close(event) {
        const btn = event.currentTarget
        const message = btn.closest('[data-flash-target="message"]')
        if (!message) return
        this.hide(message)
    }

    closeAll() {
        this.messageTargets.forEach((el) => this.hide(el))
    }

    hide(el) {
        el.style.transition = 'opacity .2s ease, transform .2s ease'
        el.style.opacity = '0'
        el.style.transform = 'translateY(-6px)'
        setTimeout(() => el.remove(), 220)
    }
}
